import script from "./ModifyAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./ModifyAlert.vue?vue&type=script&setup=true&lang=js"

import "./ModifyAlert.vue?vue&type=style&index=0&id=f8546a70&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8546a70"]])

export default __exports__